import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cookieService: CookieService) { }

  ngOnInit() {

    this.route.queryParams.skip(1).subscribe(params => {
      this.siteLang = params["loc"];
      this.cookieService.set('lang', this.siteLang);
    });

    if (window.location.search.substring(1).toString().indexOf('loc') == -1) {
      if (this.cookieService.get('lang') != '')
        this.siteLang = this.cookieService.get('lang');
      else
        this.cookieService.set('lang', 'en');
    }
  }

  siteLang: string = "en";
  

  ChangeLang(lang: string) {
   
    //set cookie as per new lang
    this.cookieService.set('lang', lang);
    this.siteLang = this.cookieService.get('lang');
  }
}
